<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FFqpbS/tc-custom/9781507303757.jpg?1733093124136" alt="This image is the cover for the book Vikings in Vietnam"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vikings in Vietnam
      </h1>
      <p class="bookDescription body article font2">
        <p>A new and exciting story about the war in Vietnam</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alessandro Giorgi
      </h2>
      
      <p class="authorDescription body article">Alessandro Giorgi is an Italian military historian, author, and teacher. He is especially interested in clandestine operations from World War II through the end of the Cold War. He has presented at academic conferences in the US and Europe and&#160; is a member of the Italian Society of Military History. This is his third book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Schiffer Publishing Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?863fc324